'use client'

import { useState, useEffect } from 'react'

import cn from 'clsx'

import { Button, BlogTile, Loading } from 'shared-components'

import FeaturePost from './FeaturePost'
import Categories from './Categories'

import s from './BlogGrid.module.sass'

function BlogGrid({ title, posts: _posts, totalPosts, featurePost, categories, showMore, getPostsByCategory }: any) {
    const [posts, setPosts] = useState(_posts)
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState('')

    const handleClick = () => {
        setIsLoadingMore(true)
        setPosts(null)
        showMore(posts?.length)
        setPosts(_posts)
        setTimeout(() => {
            setIsLoadingMore(false)
        }, 500)
    }

    const handleCategoryClick = (category: string) => {
        setIsLoading(true)
        setPosts(null)
        setSelectedCategory(category)
        getPostsByCategory(category)
        setPosts(_posts)
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }

    useEffect(() => {
        if (_posts?.length > 0) {
            setIsLoading(false)
        }
    }, [_posts])

    return (
        <section className={s.BlogGrid}>
            {featurePost && <FeaturePost post={featurePost} />}
            <div className={cn(s.Cont, 'container')}>
                {title && <h4 dangerouslySetInnerHTML={{ __html: title }} />}
                <Categories
                    categories={categories}
                    selectedCategory={selectedCategory}
                    handleCategoryClick={handleCategoryClick}
                />
                {isLoading ? (
                    <div className={s.Loading}>
                        <Loading />
                    </div>
                ) : _posts?.length === 0 && !isLoading ? (
                    <div className={s.NoPosts}>No posts found.</div>
                ) : (
                    <div className={s.Posts}>
                        {_posts?.map((post: any, index: number) => {
                            return <BlogTile post={post} key={index} />
                        })}
                    </div>
                )}
                {_posts?.length < totalPosts && !selectedCategory && !isLoading && (
                    <div className={s.ShowMore}>
                        <Button title="Show More" handleClick={handleClick} loading={isLoadingMore} />
                    </div>
                )}
            </div>
        </section>
    )
}

export default BlogGrid
